module.exports = __webpack_public_path__ + "public/img/banner-5.214515c3.jpg";